import { useUserStore } from "@src/stores/userStore";
import { NavigateFunction } from "react-router-dom";
const useRedirectIfAuthenticated = (navigate: NavigateFunction) => {
    const token = useUserStore.getState().token;
    if (tokenIsSet(token)) {
        navigate("/");
    }
};

function tokenIsSet(token: string | null) {
    if (token == null) {
        return false;
    }
    if (token !== "") {
        return true;
    }
}

export default useRedirectIfAuthenticated;
